<template>
  <Toggle :disabled="disabled" :items="items" #default="{ val: { val, name } }" @change="change">
    <img :src="name" :alt="val" />
  </Toggle>
</template>

<script>
import Toggle from '@/components/Toggle'

export default {
  name: 'Paginator',
  components: { Toggle },
  props: {
    prev: {},
    next: {},
  },
  data: () => ({
    items: {
      [require('@/assets/icons/paginator-l.svg')]: 'prev',
      [require('@/assets/icons/paginator-r.svg')]: 'next',
    },
  }),
  computed: {
    disabled() {
      return {
        prev: !this.prev,
        next: !this.next,
      }
    },
  },
  methods: {
    change(name) {
      this.$emit(name)
    },
  },
}
</script>

<style lang="scss">
.toggle-block {
  img {
    margin: 0;
  }
}
</style>
